/** 基础信息中心 **/

// 运营平台-服务管理-服务管理
const ResourceOrganMage = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/organMage'
  );
// 运营平台-服务管理-服务管理-添加服务
const ResourcenNewOrgan = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/newOrgan'
  );
// 运营平台-服务管理-服务管理-服务详情
const ResourcenOrganDetail = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/organdetail'
  );

// 运营平台-服务管理-学校管理
const ResourceSchoolMage = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/schoolMage'
  );

// 运营平台-学校管理-发布电子收据模板
const AddReceiptTemplete = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/AddReceiptTemplete'
  );
// 运营平台-服务管理-学校管理-学校详情
const ResourceSchoolDetail = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/schooldetail'
  );
// 运营平台-服务管理-学校管理-管理
const ResourceSchoolActionMage = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/ActionMage'
  );

// 运营平台-服务管理-教育局管理
const ResourceEducationMage = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/educationMage'
  );
// 运营平台-服务管理-教育局管理-教育局详情
const ResourceEducationDetail = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/educationdetail'
  );

// 机构教师(学校端查机构老师）
const Teacher = () => import('@pv/basicInfoCenter/school/organService/Teacher');

// 服务机构(学校端查关联的机构）
const Organ = () => import('@pv/basicInfoCenter/school/organService/Organ');

const OrganDetails = () => import('@pv/basicInfoCenter/school/organService/OrganDetails');

// 服务端-服务信息
const ServerManage = () =>
  import('@pv/basicInfoCenter/service/organService/ServerManage');
// 服务端-机构教师
const TeacherList = () =>
  import('@pv/basicInfoCenter/service/organService/TeacherList');

// 校园服务 - 基础信息
const BasicInfo = () => import('@pv/toBase/BasicInfo');
// 校园服务 - 基础配置
const BasicSetting = () => import('@pv/toBase/BasicSetting');
// 校园服务 - 校园信息化
const SchInfo = () => import('@pv/toBase/SchInfo');
// 校园服务 - 部门管理
const Department = () => import('@pv/toBase/Department');
// 校园服务 - 教务人员管理
const AcademicStaff = () => import('@pv/toBase/AcademicStaff');

// 校园服务 - 教师课酬梯度设置
const TeacherSalarySettingList = () =>
  import('@pv/toBase/TeacherSalarySettingList');
// 校园服务 - 教师课酬梯度设置
const TeacherSalarySettingEdit = () =>
  import('@pv/toBase/TeacherSalarySettingEdit');

// 运营管理 - 学期管理
const SysYearTerm = () => import('@pv/toBase/SysYearTerm');

// 教育局--服务管理--服务管理
const EduResourcesOrgan = () =>
  import(
    /* webpackChunkName: "education" */ '@pv/mainCenter/education/OrganResources'
  );
// 教育局--服务管理--服务详情
const EduResourcesOrganDetails = () =>
  import(
    /* webpackChunkName: "education" */ '@pv/mainCenter/education/OrganDetails'
  );

// 教育局--服务机构--学期服务机构管理
const EduSemesterOrgan = () =>
  import(
    /* webpackChunkName: "education" */ '@pv/basicInfoCenter/education/semesterOrgan'
  );

// 教育局--服务机构--配置服务学校
const EduSemesterOrganDetail = () =>
  import(
    /* webpackChunkName: "education" */ '@pv/basicInfoCenter/education/semesterOrganDetail'
  );
// 运营平台-机构管理-机构管理
const ActionOrganMage = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/ActionOrganMage'
  );

// 运营平台-单位管理-平台列表
const OperationList = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/OperationList'
  );
// 运营平台-单位管理-平台管理
const operationMage = () =>
  import(
    /* webpackChunkName: "passport" */ '@pv/basicInfoCenter/operation/resourcemage/OperationMage'
  );

// 运营管理 - 用户协议与隐私政策 添加与编辑
const UserDocumentEdit = () => import('@pv/toBase/UserDocumentEdit');

// 运营管理-班级上课时间调整
const ClassTimeAdjust = () => import('@pv/toBase/ClassTimeAdjust');

// 运营管理-新建班级上课时间调整
const ClassTimeAdjustAdd = () => import('@pv/toBase/ClassTimeAdjustAdd');

const TreOrgList = () => import('@pv/basicInfoCenter/InternalManage/TreOrgList');

const AttachmentManage = () => import('@pv/basicInfoCenter/InternalManage/AttachmentManage');

const HangingInfoSet = () => import('@pv/basicInfoCenter/InternalManage/HangingInfoSet');

export default [
  {
    path: '/operation/service/orgByope',
    name: 'operation_orgByope_orgByope',
    meta: {
      title: '服务管理',
      activePath: '/operation/service/orgByope',
      breadcrumb: '基础信息中心-服务机构-服务管理'
    },
    component: ResourceOrganMage
  },
  {
    path: '/basicInfoCenter/service/serverManage',
    name: 'basicInfoCenter_service_personnel',
    meta: {
      title: '服务信息',
      activePath: '/basicInfoCenter/service/serverManage',
      breadcrumb: '校园服务-服务机构-服务信息'
    },
    component: ServerManage
  },
  {
    path: '/basicInfoCenter/service/teacherList',
    name: 'basicInfoCenter_service_teacherList',
    meta: {
      title: '机构教师',
      activePath: '/basicInfoCenter/service/teacherList',
      breadcrumb: '校园服务-服务机构-机构教师'
    },
    component: TeacherList
  },
  {
    path: '/operation/resource/newOrgan',
    name: 'resource_newOrgan',
    meta: { title: '添加服务', isLevel4: true },
    component: ResourcenNewOrgan
  },
  {
    path: '/operation/service/orgByope/organdetail',
    name: 'resource_organdetail',
    meta: {
      title: '服务详情',
      activePath: '/operation/service/orgByope',
      breadcrumb: '基础信息中心-服务机构-服务管理-服务详情'
    },
    component: ResourcenOrganDetail
  },
  {
    path: '/basicInfoCenter/company/schoolMage',
    name: 'basicInfoCenter_company_schoolMage',
    meta: {
      title: '学校管理',
      activePath: '/basicInfoCenter/company/schoolMage',
      breadcrumb: '基础信息中心-单位管理-学校管理'
    },
    component: ResourceSchoolMage
  },
  {
    path: '/basicInfoCenter/company/schoolMage/AddReceiptTemplete',
    name: 'basicInfoCenter_company_schoolMage_addReceiptTemplete',
    meta: {
      title: '发布电子收据模板',
      activePath: '/basicInfoCenter/company/schoolMage',
      breadcrumb: '基础信息中心-单位管理-学校管理-发布电子收据模板'
    },
    component: AddReceiptTemplete
  },

  {
    path: '/basicInfoCenter/company/orgByope',
    name: 'basicInfoCenter_company_orgByope',
    meta: {
      title: '服务管理',
      activePath: '/basicInfoCenter/company/orgByope',
      breadcrumb: '基础信息中心-服务机构-服务管理'
    },
    component: ResourceOrganMage
  },
  // {
  //   path: '/operation/resource/schooldetail',
  //   name: 'resource_schooldetail',
  //   meta: { title: '学校详情', isLevel4: true },
  //   component: ResourceSchoolDetail
  // },
  {
    path: '/basicInfoCenter/company/schoolMage/detail',
    name: 'operation_company_schoolMage_detail',
    meta: {
      title: '学校详情',
      activePath: '/basicInfoCenter/company/schoolMage',
      breadcrumb: '基础信息中心-单位管理-学校管理-学校详情'
    },
    component: ResourceSchoolDetail
  },
  {
    path: '/basicInfoCenter/company/schoolMage/action',
    name: 'operation_company_schoolMage_actionmage',
    meta: {
      title: '学校详情',
      activePath: '/basicInfoCenter/company/schoolMage',
      breadcrumb: '基础信息中心-单位管理-学校管理'
    },
    component: ResourceSchoolActionMage
  },
  {
    path: '/basicInfoCenter/company/educationMage',
    name: 'basicInfoCenter_company_educationMage',
    meta: {
      title: '教育局管理',
      activePath: '/basicInfoCenter/company/educationMage',
      breadcrumb: '基础信息中心-单位管理-教育局管理'
    },
    component: ResourceEducationMage
  },
  {
    path: '/operation/resource/educationdetail',
    name: 'resource_educationdetail',
    meta: { title: '教育局详情', isLevel4: true },
    component: ResourceEducationDetail
  },
  {
    path: '/basicInfoCenter/schOrganService/teacher',
    name: 'basicInfoCenter_schOrganService_teacher',
    meta: {
      title: '机构教师',
      activePath: '/basicInfoCenter/schOrganService/teacher',
      breadcrumb: '教务中心-服务机构-机构教师'
    },
    component: Teacher
  },
  {
    path: '/basicInfoCenter/schOrganService/organ',
    name: 'basicInfoCenter_schOrganService_organ',
    meta: {
      title: '服务机构',
      activePath: '/basicInfoCenter/schOrganService/organ',
      breadcrumb: '教务中心-服务机构-服务机构'
    },
    component: Organ
  },
  {
    path: '/basicInfoCenter/schOrganService/organ/organDetails',
    name: 'basicInfoCenter_schOrganService_organ_organDetails',
    meta: {
      title: '服务机构详情',
      activePath: '/basicInfoCenter/schOrganService/organ',
      breadcrumb: '教务中心-服务机构-服务机构'
    },
    component: OrganDetails
  },
  {
    path: '/basicInfoCenter/schService/basicInfo',
    name: 'basicInfoCenter_schService_basicInfo',
    meta: {
      title: '基础信息',
      activePath: '/basicInfoCenter/schService/basicInfo',
      breadcrumb: '校园服务-基础信息'
    },
    component: BasicInfo
  },
  {
    path: '/basicInfoCenter/schService/basicSetting',
    name: 'basicInfoCenter_schService_basicSetting',
    meta: {
      title: '基础配置',
      activePath: '/basicInfoCenter/schService/basicSetting',
      breadcrumb: '校园服务-基础配置'
    },
    component: BasicSetting
  },
  {
    path: '/basicInfoCenter/schService/SchInfo',
    name: 'basicInfoCenter_schService_transition',
    meta: {
      title: '校园信息化',
      activePath: '/basicInfoCenter/schService/SchInfo',
      breadcrumb: '校园服务-校园信息化'
    },
    component: SchInfo
  },
  {
    path: '/basicInfoCenter/opeManage/department',
    name: 'basicInfoCenter_opeManage_department',
    meta: {
      title: '部门管理',
      activePath: '/basicInfoCenter/opeManage/department',
      breadcrumb: '校园服务-运营管理-部门管理'
    },
    component: Department
  },
  {
    path: '/basicInfoCenter/opeManage/academicStaff',
    name: 'basicInfoCenter_opeManage_academicStaff',
    meta: {
      title: '人员管理',
      activePath: '/basicInfoCenter/opeManage/academicStaff',
      breadcrumb: '校园服务-运营管理-教务人员管理'
    },
    component: AcademicStaff
  },
  {
    path: '/basicInfoCenter/opeManage/teacherSalarySettingList',
    name: 'basicInfoCenter_opeManage_teacherSalarySettingList',
    meta: {
      title: '教师课酬梯度设置',
      activePath: '/basicInfoCenter/opeManage/teacherSalarySettingList',
      breadcrumb: '基础信息中心-运营管理-教师课酬梯度设置'
    },
    component: TeacherSalarySettingList
  },
  {
    path: '/basicInfoCenter/opeManage/teacherSalarySettingList/teacherSalarySettingAdd',
    name: 'basicInfoCenter_opeManage_teacherSalarySettingAdd',
    meta: {
      title: '添加教师课酬梯度',
      activePath: '/basicInfoCenter/opeManage/teacherSalarySettingList',
      breadcrumb: '基础信息中心-运营管理-教师课酬梯度设置-添加教师课酬梯度'
    },
    component: TeacherSalarySettingEdit
  },
  {
    path: '/basicInfoCenter/opeManage/teacherSalarySettingList/teacherSalarySettingEdit',
    name: 'basicInfoCenter_opeManage_teacherSalarySettingEdit',
    meta: {
      title: '编辑教师课酬梯度',
      activePath: '/basicInfoCenter/opeManage/teacherSalarySettingList',
      breadcrumb: '基础信息中心-运营管理-教师课酬梯度设置-编辑教师课酬梯度'
    },
    component: TeacherSalarySettingEdit
  },
  {
    path: '/basicInfoCenter/opeManage/teacherSalarySettingList/relSchoolSetting',
    name: 'basicInfoCenter_opeManage_relSchoolSetting',
    meta: {
      title: '配置适用学校',
      activePath: '/basicInfoCenter/opeManage/teacherSalarySettingList',
      breadcrumb: '基础信息中心-运营管理-教师课酬梯度设置-配置适用学校'
    },
    component: TeacherSalarySettingEdit
  },
  {
    path: '/basicInfoCenter/opeManage/sysYearTerm',
    name: 'basicInfoCenter_opeManage_sysYearTerm',
    meta: {
      title: '当前学期管理',
      activePath: '/basicInfoCenter/opeManage/sysYearTerm',
      breadcrumb: '基础信息中心-运营管理-当前学期管理'
    },
    component: SysYearTerm
  },
  {
    path: '/education/resources/organ',
    name: 'resources_organ',
    meta: {
      title: '服务管理',
      activePath: '/education/resources/organ',
      breadcrumb: '基础信息中心-服务机构-服务管理'
    },
    component: EduResourcesOrgan
  },
  {
    path: '/education/resources/organ/details',
    name: 'resources_organ_details',
    meta: {
      title: '服务详情',
      activePath: '/education/resources/organ',
      breadcrumb: '基础信息中心-服务机构-服务管理-服务详情'
    },
    component: EduResourcesOrganDetails
  },
  {
    path: '/education/resources/semesterorgan',
    name: 'semester_organ',
    meta: {
      title: '学期服务机构管理',
      activePath: '/education/resources/semesterorgan',
      breadcrumb: '基础信息中心-服务机构-学期服务机构管理'
    },
    component: EduSemesterOrgan
  },
  {
    path: '/education/resources/semesterorgan/detail',
    name: 'semester_orgdetail',
    meta: {
      title: '配置服务学校',
      activePath: '/education/resources/semesterorgan',
      breadcrumb: '基础信息中心-服务机构-学期服务机构管理-配置服务学校'
    },
    component: EduSemesterOrganDetail
  },
  {
    path: '/basicInfoCenter/company/orgByope/action',
    name: 'basicInfoCenter_company_orgByopeAction',
    meta: {
      title: '服务机构',
      activePath: '/basicInfoCenter/company/orgByope',
      breadcrumb: '基础信息中心-单位管理-服务机构'
    },
    component: ActionOrganMage
  },
  {
    path: '/basicInfoCenter/company/operationList',
    name: 'basicInfoCenter_company_operationList',
    meta: {
      title: '平台管理',
      activePath: '/basicInfoCenter/company/operationList',
      breadcrumb: '基础信息中心-单位管理-平台管理'
    },
    component: OperationList
  },
  {
    path: '/basicInfoCenter/company/operationList/action',
    name: 'basicInfoCenter_company_operationAction',
    meta: {
      title: '平台管理',
      activePath: '/basicInfoCenter/company/operationList',
      breadcrumb: '基础信息中心-单位管理-平台管理'
    },
    component: operationMage
  },
  {
    path: '/basicInfoCenter/opeManage/userDocumentEdit',
    name: 'basicInfoCenter_opeManage_userDocumentEdit',
    meta: {
      title: '用户协议、隐私政策',
      activePath: '/basicInfoCenter/opeManage/userDocumentEdit',
      breadcrumb: '基础信息中心-运营管理-用户协议、隐私政策'
    },
    component: UserDocumentEdit
  },
  {
    path: '/basicInfoCenter/opeManage/classTimeAdjust',
    name: 'basicInfoCenter_opeManage_classTimeAdjust',
    meta: {
      title: '班级上课时间调整',
      activePath: '/basicInfoCenter/opeManage/classTimeAdjust',
      breadcrumb: '基础信息中心-运营管理-班级上课时间调整'
    },
    component: ClassTimeAdjust
  },

  {
    path: '/basicInfoCenter/opeManage/classTimeAdjust/classTimeAdjustAdd',
    name: 'basicInfoCenter_opeManage_classTimeAdjust_classTimeAdjustAdd',
    meta: {
      title: '新建班级上课时间调整',
      activePath: '/basicInfoCenter/opeManage/classTimeAdjust',
      breadcrumb: '基础信息中心-运营管理-班级上课时间调整-新建班级上课时间调整'
    },
    component: ClassTimeAdjustAdd
  },
  {
    path: '/basicInfoCenter/internalManage/treOrgList',
    name: 'basicInfoCenter_internalManage_treOrgList',
    meta: {
      title: '三方课程机构',
      activePath: '/basicInfoCenter/internalManage/treOrgList',
      breadcrumb: '基础信息中心-内部管理-三方课程机构'
    },
    component: TreOrgList
  },
  {
    path: '/basicInfoCenter/internalManage/attachmentManage',
    name: 'basicInfoCenter_internalManage_attachmentManage',
    meta: {
      title: '挂靠分账管理',
      activePath: '/basicInfoCenter/internalManage/attachmentManage',
      breadcrumb: '基础信息中心-内部管理-挂靠分账管理'
    },
    component: AttachmentManage
  },
  {
    path: '/basicInfoCenter/internalManage/attachmentManage/hangingInfoSet',
    name: 'basicInfoCenter_internalManage_attachmentManage_hangingInfoSet',
    meta: {
      title: '配置分账信息',
      activePath: '/basicInfoCenter/internalManage/attachmentManage',
      breadcrumb: '基础信息中心-内部管理-挂靠分账管理-配置分账信息'
    },
    component: HangingInfoSet
  }

];
